import { render, staticRenderFns } from "./ProblemAdd.vue?vue&type=template&id=bb93d3ae"
import script from "./ProblemAdd.vue?vue&type=script&lang=js"
export * from "./ProblemAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports